export default __webpack_public_path__ + "static/media/hummus_with_pine_nuts.99b545b2.jpg";